import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {injectIntl, FormattedMessage} from 'react-intl';

import types from '../../common/model-api/types';
import {renderProgress} from '../jobs/JobView.react';
import {STATUS_FINISHED, STATUS_FAILED, STATUS_IN_PROGRESS, STATUS_WAITING} from '../../common/model-api/JobType';
import GitPullTodayMutation from './GitPullTodayMutation.react';

/* global setInterval, clearInterval */

class GitPullK8sProgress extends React.Component {
	static propTypes = {
		completed: PropTypes.bool,
		intl: PropTypes.object.isRequired,
		jobName: PropTypes.string,
		jobStatus: PropTypes.string,
		progressPercent: PropTypes.number,
	};

	constructor(props) {
		super(props);
		const initialStatus = props.jobStatus || 'pending';
		this.state = {
			jobStatus: initialStatus,
			progressPercent: this.estimateProgress(initialStatus, Number.isFinite(props.progressPercent) ? props.progressPercent : 0),
			completed: !!props.completed,
		};
	}

	estimateProgress = (jobStatus, previousPercent = 0) => {
		if (jobStatus === 'succeeded' || jobStatus === 'failed') {
			return 100;
		}

		if (jobStatus === 'not-found') {
			return 0;
		}

		if (jobStatus === 'pending') {
			return 5;
		}

		if (jobStatus === 'running') {
			return Math.min(95, Math.max(12, previousPercent + 6));
		}

		return Math.max(5, previousPercent);
	};

	componentDidMount() {
		if (this.props.jobName && !this.state.completed) {
			this.refreshTask = setInterval(() => {
				this.pollStatus();
			}, 4000);
		}
	}

	componentWillUnmount() {
		if (this.refreshTask) {
			clearInterval(this.refreshTask);
		}
	}

	pollStatus = () => {
		if (!this.props.jobName) {
			return;
		}

		Relay.Store.commitUpdate(new GitPullTodayMutation({
			checkOnly: true,
			jobName: this.props.jobName,
		}), {
			onSuccess: (response) => {
				const payload = response && response.runGitPullTodayJob;
				if (!payload) {
					return;
				}

				this.setState({
					jobStatus: payload.jobStatus || 'pending',
					progressPercent: this.estimateProgress(payload.jobStatus || 'pending', this.state.progressPercent),
					completed: !!payload.completed,
				}, () => {
					if (this.state.completed && this.refreshTask) {
						clearInterval(this.refreshTask);
					}
				});
			},
			onFailure: () => {
				this.setState({
					jobStatus: 'failed',
					progressPercent: 100,
					completed: true,
				});
				if (this.refreshTask) {
					clearInterval(this.refreshTask);
				}
			}
		});
	};

	getVirtualJob = () => {
		const status = this.state.jobStatus;
		const percent = Math.max(0, Math.min(100, Number(this.state.progressPercent) || 0));

		if (status === 'succeeded') {
			return {
				status: STATUS_FINISHED,
				progress: {
					running: false,
					currentProgress: 100,
					maxProgress: 100,
				},
			};
		}

		if (status === 'failed') {
			return {
				status: STATUS_FAILED,
				progress: {
					running: false,
					currentProgress: 100,
					maxProgress: 100,
				},
			};
		}

		if (status === 'not-found') {
			return {
				status: STATUS_WAITING,
				progress: {
					running: true,
					currentProgress: 0,
					maxProgress: 100,
				},
			};
		}

		return {
			status: STATUS_IN_PROGRESS,
			progress: {
				running: true,
				currentProgress: percent,
				maxProgress: 100,
			},
		};
	};

	render() {
		const type = types.jobs;
		const virtualJob = this.getVirtualJob();

		return (
			<div className="jobProgress">
				<div className="layout-row">
					<div className="flex-none"><FormattedMessage defaultMessage="Progress:" id="job.progressTitle" />&nbsp;</div>
					<div className="flex progressWrapper">
						{renderProgress(type, virtualJob, this.props.intl.formatMessage)}
					</div>
				</div>
				<div>
					<small>
						<FormattedMessage defaultMessage="Běží jako samostatný job v k8s." id="gitPull.k8sStandaloneNote" />
					</small>
				</div>
			</div>
		);
	}
}

export default injectIntl(GitPullK8sProgress);
